import { makeStyles } from "@material-ui/core/styles";

export const useRestaurantEditStyles = () => {
  const useStyles = makeStyles((theme) => ({
    mt10: {
      marginTop: 10,
    },
    mt20: {
      marginTop: 20,
    },
    mt40: {
      marginTop: 40,
    },
    mt50: {
      marginTop: 50,
    },
    mt80: {
      marginTop: 80,
    },
    ml20: {
      marginLeft: 20,
    },
    mb30: {
      marginBottom: 30,
    },
    textFieldStyles: {
      width: "100%",
      "&:focus": {
        border: "1px solid #476b6b",
      },
    },
    iconStyles: {
      color: "#fff",
      height: 160,
      width: 160,
    },
    avatarStyles: {
      height: 180,
      width: 180,
      background: "#09C491",
      cursor: "pointer",
    },
    container: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow:
        "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
    },
  }));
  const classes = useStyles();
  return classes;
};
